import type { ReactElement, ReactNode } from 'react';
import styles from './VenueCard.module.scss';
import type {
  PreviewVenue,
  HighlightCapacityType
} from '../venueCardInternalModules/types';
import { VenueImage } from '../venueCardInternalModules/VenueImage';
import { VenueInfo } from '../venueCardInternalModules/VenueInfo';

type Props = {
  venue: PreviewVenue;
  onClickVenueLink?: () => void;
  openInNewTab: boolean;
  children?: ReactNode;
  featuredVenueIcon?: ReactNode;
  highlightCapacity?: HighlightCapacityType;
};

export function VenueCardTemplate({
  venue,
  onClickVenueLink,
  openInNewTab,
  children,
  featuredVenueIcon,
  highlightCapacity
}: Props): ReactElement {
  return (
    <div className={styles.venueCard}>
      <VenueImage
        venue={venue}
        onClickVenueLink={onClickVenueLink}
        openInNewTab={openInNewTab}
        featuredVenueIcon={featuredVenueIcon}
      />
      <VenueInfo
        venue={venue}
        onClickVenueLink={onClickVenueLink}
        openInNewTab={openInNewTab}
        highlightCapacity={highlightCapacity}
      >
        {children}
      </VenueInfo>
    </div>
  );
}
